import React from 'react';
import { Tooltip } from '../../../../ui-toolkit';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

export const WitnessTooltip: FCWithChildren = ({ children }) => {
  return (
    <Tooltip
      tooltipContent={
        <div className={'w-72'} data-test-id={'signing-appointment-witness-tooltip'}>
          This field indicates the number of "friends" (i.e. non-notary individuals) needed to act as a witness for
          signing in each state for a standard deed signing. Witness requirements for POAs, using a "mark" instead of a
          signature, and other special circumstances are not captured here.
        </div>
      }
      trigger={'hover'}
      placement={'top'}
    >
      {children}
    </Tooltip>
  );
};
